import React, { useState } from 'react'
import {
  Grid,
  Table,
  TableHeaderRow,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-bootstrap4'
import {
  Column,
  TableColumnWidthInfo,
  SortingState,
  IntegratedSorting,
} from '@devexpress/dx-react-grid'
import { Release } from '../types/AnalyticsProps'
import formatCurrency from '../utils/formatCurrency'

interface TopReleasesTableProps {
  data: Release[]
}

const TopReleasesTable: React.FunctionComponent<TopReleasesTableProps> = ({ data }) => {
  const columns: ReadonlyArray<Column> = [
    { name: 'release_title', title: 'Release Title' },
    { name: 'release_artist', title: 'Artist' },
    { name: 'cat_no', title: 'Cat No.' },
    { name: 'total', title: 'Value' },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'release_title', width: 'auto' },
    { columnName: 'release_artist', width: 'auto' },
    { columnName: 'cat_no', width: 'auto' },
    { columnName: 'total', width: 'auto' },
  ]

  const [columnExtensions] = useState<Array<Table.ColumnExtension>>([
    { columnName: 'total', align: 'right' },
  ])

  const TableCell = ({ value, column }: any) => {
    if (column.name === 'total') {
      return <td className='text-right'>{formatCurrency(value)}</td>
    }
    return <td>{value}</td>
  }

  return (
    <>
      <h4>Top Releases</h4>
      <Grid rows={data} columns={columns}>
        <SortingState />
        <IntegratedSorting />
        <Table cellComponent={TableCell} columnExtensions={columnExtensions} />
        <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
        <TableHeaderRow showSortingControls />
      </Grid>
    </>
  )
}

export default TopReleasesTable
